/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { EnableUserOptions, EnableUserResponses } from '../types/EnableUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Enable a disabled user
 * {@link /v1/user/:user_id/enable}
 */
export function enableUser<ThrowOnError extends boolean = true>(
  options: Options<EnableUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<EnableUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/user/{user_id}/enable',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<EnableUserResponses, ThrowOnError>>,
  )
}
